import { useRef, useEffect, useState, useCallback } from "react";
import "../index.scss";
import { BlogIcon, MinusIcon, PlusIcon, ViewIcon } from "@shopify/polaris-icons";
import { Badge, Button } from "@shopify/polaris";
import Langauge from "../../../../i18n/Language";
const t = Langauge;

const KeywordPanelSvg = (props) => {

    const {
        topicList,
        jumpLoading,

        handleViewPageItem,
        handleGenerateBlog,
        handleViewBlog,
    } = props;

    const svgRef = useRef(null);
    const viewGroupRef = useRef(null);
    const activeTopicIdRef = useRef(-1);
    const hoverTopicIdRef = useRef(-1);
    const hoverTimerRef = useRef(null);
    const hoverTimerTopicRef = useRef(null);
    const svgPercentRef = useRef(150);
    const zoomOperaTimerRef = useRef(null);
    const topicViewRef = useRef(null);

    // 使用 useRef 保存不需要重新渲染的值
    // 默认150%，首个话题(400,400)居中于 viewBox 中心(1000,400)
    const matrixRef = useRef([1.6, 0, 0, 1.6, 360, -240]);
    const isDraggingRef = useRef(false);
    const lastPositionRef = useRef({ x: 0, y: 0 });
    const needsUpdateRef = useRef(false);
    const pillarScaleRef = useRef(1);
    const pillarTranslateRef = useRef({ x: -100, y: -30 });

    // 常量
    const minScale = 0.7;
    const maxScale = 2;

    const [activeTopicId, setActiveTopicId] = useState(-1);
    const [hoverTopicId, setHoverTopicId] = useState(-1);
    const [isShowGlassPanel, setIsShowGlassPanel] = useState(true);    // 是否显示玻璃面板
    const [pillarScale, setPillarScale] = useState(1);
    const [pillarTranslate, setPillarTranslate] = useState({ x: -100, y: -30 });
    const [pillarTranslateOther, setPillarTranslateOther] = useState({ x: -95, y: -15 });
    const [hoverNodeId, setHoverNodeId] = useState(-1);
    const [viewLoading, setViewLoading] = useState(false);
    const [svgPercent, setSvgPercent] = useState(150);

    // 弹出卡片状态
    const [popupCard, setPopupCard] = useState({
        isVisible: false,
        topicId: null,
        position: { x: 0, y: 0 },
        data: null,
        type: ''
    });

    const [popupTopicCard, setPopupTopicCard] = useState({
        isVisible: false,
        topicId: null,
        position: { x: 0, y: 0 },
        data: null,
        type: 'topic'
    });

    // 应用变换矩阵
    const applyMatrix = useCallback(() => {
        if (viewGroupRef.current) {
            viewGroupRef.current.setAttribute("transform", `matrix(${matrixRef.current.join(" ")})`);
        }
    }, []);

    // 调度更新
    const scheduleUpdate = useCallback(() => {
        if (!needsUpdateRef.current) {
            needsUpdateRef.current = true;
            requestAnimationFrame(() => {
                applyMatrix();
                needsUpdateRef.current = false;
            });
        }
    }, [applyMatrix]);

    // 获取当前缩放值
    const getCurrentScale = useCallback(() => {
        return matrixRef.current[0]; // 因为我们保持 x/y 同比缩放
    }, []);

    // 鼠标按下事件处理
    const handleMouseDown = useCallback((e) => {
        isDraggingRef.current = true;
        lastPositionRef.current = { x: e.clientX, y: e.clientY };
    }, []);

    // 鼠标移动事件处理
    const handleMouseMove = useCallback((e) => {
        if (!isDraggingRef.current) return;

        const dx = e.clientX - lastPositionRef.current.x;
        const dy = e.clientY - lastPositionRef.current.y;

        // 将屏幕坐标的移动距离转换为SVG坐标系的移动距离
        if (svgRef.current) {
            const rect = svgRef.current.getBoundingClientRect();
            const viewBox = svgRef.current.viewBox.baseVal;

            // preserveAspectRatio="xMidYMid meet"：实际是等比缩放，
            // 需用统一的缩放系数，否则宽高比不一致时（如容器被拉宽）拖动会变慢/迟缓
            const renderScale = Math.min(rect.width / viewBox.width, rect.height / viewBox.height) || 1;

            // 转换鼠标移动距离到SVG坐标系
            const svgDx = dx / renderScale;
            const svgDy = dy / renderScale;

            matrixRef.current[4] += svgDx;
            matrixRef.current[5] += svgDy;
        } else {
            // 降级处理：如果无法获取SVG信息，使用原来的方式
            matrixRef.current[4] += dx;
            matrixRef.current[5] += dy;
        }

        lastPositionRef.current = { x: e.clientX, y: e.clientY };

        scheduleUpdate();
    }, [scheduleUpdate]);

    // 鼠标抬起事件处理
    const handleMouseUp = useCallback(() => {
        isDraggingRef.current = false;
    }, []);

    // 鼠标离开事件处理
    const handleMouseLeave = useCallback(() => {
        isDraggingRef.current = false;
    }, []);

    // 保证文案模块缩放大小相同
    const handlePillarZoomScale = useCallback(() => {
        const newPlScale = 1.6 / matrixRef.current[0];
        const newPlTranslate = { x: -160 / matrixRef.current[0], y: -50 / matrixRef.current[0] };
        const newPlTranslateOther = { x: -160 / matrixRef.current[0], y: -25 / matrixRef.current[0] };
        pillarScaleRef.current = newPlScale;
        pillarTranslateRef.current = newPlTranslate;
        setPillarScale(newPlScale);
        setPillarTranslate(newPlTranslate);
        setPillarTranslateOther(newPlTranslateOther);
    }, []);

    // 鼠标滚轮事件处理
    const handleWheel = useCallback((e) => {
        e && e.preventDefault();
        // if (zoomOperaTimerRef.current) {
        //     clearTimeout(zoomOperaTimerRef.current);
        //     zoomOperaTimerRef.current = null;
        // }

        // 更新缩放比例
        let newSvgPercent = e.deltaY < 0 ? svgPercentRef.current + 10 : svgPercentRef.current - 10;
        if (newSvgPercent <= 70) {
            newSvgPercent = 70;
        }
        if (newSvgPercent >= 170) {
            newSvgPercent = 170;
        }
        setSvgPercent(newSvgPercent);
        svgPercentRef.current = newSvgPercent;

        const scaleFactor = e.deltaY < 0 ? 1.1 : 0.9;
        const currentScale = getCurrentScale();
        const nextScale = currentScale * scaleFactor;

        // 缩放限制
        if (nextScale < minScale || nextScale > maxScale) return;

        // 获取鼠标在SVG坐标系中的位置
        const rect = svgRef.current.getBoundingClientRect();
        const clientX = e.clientX - rect.left;
        const clientY = e.clientY - rect.top;

        // 将屏幕坐标转换为SVG坐标
        const svgPoint = screenToSvg(clientX, clientY);

        // 计算缩放前的鼠标在变换后坐标系中的位置
        const beforeX = (svgPoint.x - matrixRef.current[4]) / matrixRef.current[0];
        const beforeY = (svgPoint.y - matrixRef.current[5]) / matrixRef.current[3];

        // 应用新的缩放
        matrixRef.current[0] = nextScale;  // scaleX
        matrixRef.current[3] = nextScale;  // scaleY

        // 重新计算平移，使鼠标位置保持不变
        matrixRef.current[4] = svgPoint.x - beforeX * nextScale;  // translateX
        matrixRef.current[5] = svgPoint.y - beforeY * nextScale;  // translateY

        // 保证文案模块缩放大小相同
        handlePillarZoomScale();

        // 添加动画效果
        // viewGroupRef.current.classList.add('animate-transform');

        scheduleUpdate();

        // 移除动画class
        // zoomOperaTimerRef.current = setTimeout(() => {
        //     if (viewGroupRef.current) {
        //         viewGroupRef.current.classList.remove('animate-transform');
        //     }
        // }, 400);

    }, [getCurrentScale, scheduleUpdate, minScale, maxScale]);


    // 将屏幕坐标转换为SVG viewBox坐标
    const screenToSvg = useCallback((x, y) => {
        if (!svgRef.current) return { x: 0, y: 0 };

        // 将屏幕坐标转换为SVG viewBox坐标
        const rect = svgRef.current.getBoundingClientRect();
        const viewBox = svgRef.current.viewBox.baseVal;

        // preserveAspectRatio="xMidYMid meet"：等比缩放并居中，需考虑上下/左右留白偏移
        const renderScale = Math.min(rect.width / viewBox.width, rect.height / viewBox.height) || 1;
        const offsetX = (rect.width - viewBox.width * renderScale) / 2;
        const offsetY = (rect.height - viewBox.height * renderScale) / 2;

        return {
            x: (x - offsetX) / renderScale + viewBox.x,
            y: (y - offsetY) / renderScale + viewBox.y
        };
    }, []);

    // 居中并缩放元素
    const centerAndZoomOnElement = useCallback((target) => {
        if (!svgRef.current || !viewGroupRef.current) return;

        // 获取元素在SVG坐标系中的边界框
        const bbox = target.getBBox();

        // 获取元素当前的transform（如果有的话）
        const transform = target.getAttribute('transform');
        let elementX = bbox.x + bbox.width / 2;
        let elementY = bbox.y + bbox.height / 2;

        // 解析transform属性中的translate值
        if (transform) {
            const translateMatch = transform.match(/translate\(([^,]+),([^)]+)\)/);
            if (translateMatch) {
                elementX += parseFloat(translateMatch[1]);
                elementY += parseFloat(translateMatch[2]);
            }
        }

        // 获取SVG的viewBox尺寸
        const viewBox = svgRef.current.viewBox.baseVal;
        const svgWidth = viewBox.width;
        const svgHeight = viewBox.height;

        // 计算适合的缩放比例，考虑一些边距
        // const margin = Math.min(bbox.width, bbox.height) * 0.5; // 添加50%的边距
        // const scaleX = svgWidth / (bbox.width + margin);
        // const scaleY = svgHeight / (bbox.height + margin);
        // const targetScale = Math.min(scaleX, scaleY, maxScale);
        const targetScale = 1.6;

        // 计算新的transform matrix
        // 目标：将元素中心移动到视图中心，并应用缩放
        const centerX = svgWidth / 2;
        const centerY = svgHeight / 2;

        const newTx = centerX - elementX * targetScale;
        const newTy = centerY - elementY * targetScale;

        // 更新matrix数组
        matrixRef.current = [targetScale, 0, 0, targetScale, newTx, newTy];

        // 添加动画效果
        viewGroupRef.current.classList.add('animate-transform');

        // 应用变换
        applyMatrix();

        // 更新缩放比例
        let newSvgPercent = 150;
        setSvgPercent(newSvgPercent);
        svgPercentRef.current = newSvgPercent;

        // 移除动画class
        setTimeout(() => {
            if (viewGroupRef.current) {
                viewGroupRef.current.classList.remove('animate-transform');
            }
        }, 500);
    }, [applyMatrix, maxScale]);

    // 点击事件处理
    const handleElementClick = useCallback((e, element) => {
        e.stopPropagation(); // 阻止事件冒泡避免和背景拖拽冲突

        let topicId = element.dataset.topic;
        activeTopicIdRef.current = topicId;
        setActiveTopicId(topicId);
        // 设置卡片
        pillarScaleRef.current = 1;
        pillarTranslateRef.current = { x: -100, y: -30 };
        setPillarScale(1);
        setPillarTranslate({ x: -100, y: -30 });
        setPillarTranslateOther({ x: -95, y: -15 });

        centerAndZoomOnElement(element);

        // 查看对应topic
        let tId = e.target.closest('.topic-svg-module').dataset.topicId;
        handleViewPageItem(tId, -1);
    }, [centerAndZoomOnElement]);

    // 鼠标悬停事件
    const handleElementMouseEnter = useCallback((e, element) => {
        let topicId = element.dataset.topic;
        hoverTopicIdRef.current = topicId;
        setHoverTopicId(topicId);
        bringToFront(element, 'enter');
    }, []);

    // 鼠标离开事件
    const handleElementMouseLeave = useCallback((e, element) => {
        hoverTopicIdRef.current = -1;
        setHoverTopicId(-1);
        bringToFront(element, 'leave');
    }, []);

    // 显示弹出卡片 - 跟随文字位置，垂直居中，最高层级
    const showPopupCard = useCallback((id, textElement, type) => {
        let ObjItem = {
            title: '',
            keywordsCount: 0,
            volume: 0,
            kd: 0
        };
        // 判断是支柱页面还是子页面
        if (type === 'pillar') {
            ObjItem = topicList.find(item => item.id === id);
        } else if (type === 'subpage') {
            topicList.forEach(item => {
                if (item.subkeywords.find(i => i.id === id)) {
                    ObjItem = item.subkeywords.find(i => i.id === id);
                }
            })
        }
        if (!ObjItem || !textElement) return;
        // 计算文字模块的屏幕位置
        const textBBox = textElement.getBoundingClientRect();
        // 计算相对于视窗的位置
        const targetX = textBBox.right; // 文字右侧
        const targetY = textBBox.top + textBBox.height / 2; // 文字垂直中心

        setPopupCard({
            isVisible: true,
            topicId: ObjItem.topic_id,
            position: { x: targetX, y: targetY },
            data: {
                id: type === 'pillar' ? ObjItem.pillar_id : ObjItem.page_id,
                title: ObjItem?.title || '',
                keywordsCount: ObjItem?.keywordsCount || 0,
                totalSearchVolume: ObjItem?.volume || 0, // 模拟数据
                avgKD: ObjItem?.kd || 0,
                isCovered: Boolean(ObjItem?.cover),
                blog_config_id: ObjItem?.blog_config_id || -1,
            },
            type
        });
    }, [topicList]);

    // 隐藏弹出卡片
    const hidePopupCard = useCallback(() => {
        setPopupCard(prev => ({ ...prev, isVisible: false, type: '' }));
    }, []);

    // 处理文字鼠标悬停事件 - 传递文字元素
    const handleTextMouseEnter = useCallback((e, id, isTip, type) => {
        handlePillarMouseTopicLeave();
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
        if (hoverTimerTopicRef.current) {
            clearTimeout(hoverTimerTopicRef.current);
            hoverTimerTopicRef.current = null;
        }
        e.stopPropagation();
        // 如果当前是提示词，则显示弹出卡片
        if (isTip) {
            showPopupCard(id, e.currentTarget, type);
        }
    }, [showPopupCard]);

    // 处理支柱鼠标离开事件
    const handlePillarMouseLeave = useCallback(() => {
        // 延迟隐藏，给用户时间移动到卡片上
        hoverTimerRef.current = setTimeout(() => {
            if (!document.querySelector('.keyword-popup-card:hover')) {
                hidePopupCard();
            }
        }, 100);
    }, [hidePopupCard]);

    // node节点鼠标悬停事件
    const handleNodeMouseEnter = useCallback((e, element) => {
        e.stopPropagation();
        // 设置触摸节点的id
        setHoverNodeId(element.id);
        bringToFront(element, 'enter');
    }, []);

    // node节点鼠标离开事件
    const handleNodeMouseLeave = useCallback((e, element, type, index) => {
        e.stopPropagation();
        if (type !== 'topic' && index > 0) {
            bringToFront(element, 'leave');
        }
        setHoverNodeId(-1);
    }, []);

    // 话题 ---------------- 大圈 
    const showPopupTopicCard = useCallback((id, textElement, type) => {
        let ObjItem = {
            title: '',
            keywordsCount: 0,
            volume: 0,
            kd: 0
        };
        if (!ObjItem || !textElement) return;
        // 计算文字模块的屏幕位置
        const textBBox = textElement.getBoundingClientRect();
        // 计算相对于视窗的位置
        const targetX = textBBox.right; // 文字右侧
        const targetY = textBBox.top + textBBox.height / 2; // 文字垂直中心
        ObjItem = topicList.find(item => item.id === id);
        setPopupTopicCard({
            isVisible: true,
            topicId: ObjItem.topic_id,
            position: { x: targetX, y: targetY },
            data: {
                id: ObjItem.topic_id,
                title: ObjItem?.topic_title || '',
                keywordsCount: 0,
                totalSearchVolume: ObjItem?.topic_volume || 0, // 模拟数据
                avgKD: ObjItem?.topic_kd || 0,
                isCovered: false,
                blog_config_id: null,
            },
            type
        });
    }, [topicList]);

    const hidePopupTopicCard = useCallback(() => {
        setPopupTopicCard(prev => ({ ...prev, isVisible: false }));
    }, []);

    // 话题节点鼠标悬停事件
    const handleTextMouseTopicEnter = useCallback((e, id, isTip, type) => {
        handlePillarMouseLeave();
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
        if (hoverTimerTopicRef.current) {
            clearTimeout(hoverTimerTopicRef.current);
            hoverTimerTopicRef.current = null;
        }
        e.stopPropagation();
        // 如果当前是提示词，则显示弹出卡片
        if (isTip) {
            const topicModuleDom = document.getElementById(`topic-module-${id}`);
            topicViewRef.current = setTimeout(() => {
                showPopupTopicCard(id, topicModuleDom, type);
            }, 200);
        }
    }, [showPopupTopicCard]);

    // 话题节点鼠标离开事件
    const handlePillarMouseTopicLeave = useCallback(() => {
        if (topicViewRef.current) {
            clearTimeout(topicViewRef.current);
            topicViewRef.current = null;
        }
        // 延迟隐藏，给用户时间移动到卡片上
        hoverTimerTopicRef.current = setTimeout(() => {
            if (!document.querySelector('.keyword-popup-topic-card:hover')) {
                hidePopupTopicCard();
            }
        }, 100);
    }, [hidePopupTopicCard]);

    // 放大放小操作
    const handleZoomOpera = useCallback((type) => {
        if (zoomOperaTimerRef.current) {
            clearTimeout(zoomOperaTimerRef.current);
            zoomOperaTimerRef.current = null;
        }
        // 最小10， 最大100
        let newSvgPercent = type === 'minus' ? svgPercent - 10 : svgPercent + 10;
        if (newSvgPercent < 70 || newSvgPercent > 170) return;
        svgPercentRef.current = newSvgPercent;
        setSvgPercent(newSvgPercent);
        // svg比例
        const scaleFactor = type === 'minus' ? 0.9 : 1.1;
        const currentScale = getCurrentScale();
        const nextScale = currentScale * scaleFactor;
        if (nextScale < minScale || nextScale > maxScale) return;

        // 获取SVG中心点作为缩放基点
        const svgCenterX = 1000; // viewBox width / 2 (2000 / 2)
        const svgCenterY = 400;  // viewBox height / 2 (800 / 2)

        // 计算缩放前中心点在变换后坐标系中的位置
        const beforeX = (svgCenterX - matrixRef.current[4]) / matrixRef.current[0];
        const beforeY = (svgCenterY - matrixRef.current[5]) / matrixRef.current[3];

        // 应用新的缩放
        matrixRef.current[0] = nextScale;
        matrixRef.current[3] = nextScale;

        // 重新计算平移，使中心点位置保持不变
        matrixRef.current[4] = svgCenterX - beforeX * nextScale;
        matrixRef.current[5] = svgCenterY - beforeY * nextScale;

        // 保证文案模块缩放大小相同
        handlePillarZoomScale();

        // 添加动画效果
        viewGroupRef.current.classList.add('animate-transform');

        // 应用变换
        applyMatrix();
        // 移除动画class
        zoomOperaTimerRef.current = setTimeout(() => {
            if (viewGroupRef.current) {
                viewGroupRef.current.classList.remove('animate-transform');
            }
        }, 400);
    }, [svgPercent]);

    // 使用useEffect替代直接DOM操作
    useEffect(() => {
        // 初始化变换矩阵
        applyMatrix();
    }, [applyMatrix]);

    useEffect(() => {
        let activeId = topicList[0].id;
        activeTopicIdRef.current = activeId;
        setActiveTopicId(activeId);
        setTimeout(() => {
            setIsShowGlassPanel(false);
        }, 500);
    }, [topicList]);

    useEffect(() => {
        setViewLoading(jumpLoading);
    }, [jumpLoading]);

    useEffect(() => {
        const svg = svgRef.current;
        svg.addEventListener("wheel", handleWheel, { passive: false });

        return () => svg.removeEventListener("wheel", handleWheel);
    }, []);

    // 渲染弹出卡片 - 话题
    const renderTopicPopupCard = useCallback(() => {
        if (!popupTopicCard.data) return null;

        let isShow = true;
        if (!popupTopicCard.isVisible || !popupTopicCard.data || !popupTopicCard.position || popupTopicCard.type !== 'topic') {
            isShow = false;
        }

        const { data, position } = popupTopicCard;

        // 卡片尺寸
        const cardWidth = 210;
        const cardHeight = 125;
        const triangleSize = 8;
        const gap = 16; // 与文字的间距
        const t_width = document.getElementById('topic-popup-card')?.offsetWidth || 200;

        // 计算卡片位置（在文字右侧，垂直居中对齐）
        let cardtX = position.x - 145;
        let cardtY = position.y - cardHeight - 25; // 以文字中心为基准垂直居中

        // 边界检测
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        // 右边界检测 - 如果右侧空间不足，显示在左侧
        let isOnLeft = false;
        if (cardtX + cardWidth > viewportWidth - 20) {
            cardtX = position.x - cardWidth - gap;
            isOnLeft = true;
        }

        // 上边界检测
        if (cardtY < 20) {
            cardtY = 20;
        }

        // 下边界检测
        if (cardtY + cardHeight > viewportHeight - 20) {
            cardtY = viewportHeight - cardHeight - 20;
        }

        // 计算三角形位置
        const triangleX = isOnLeft ? cardWidth - 1 : -triangleSize;
        const triangleY = Math.max(
            triangleSize * 2,
            Math.min(
                cardHeight - triangleSize * 2,
                position.y - cardtY
            )
        );

        return (
            <div
                id="topic-popup-card"
                className="keyword-popup-topic-card"
                style={{
                    // 固定定位，跟随文字位置，最高层级
                    position: 'fixed',
                    left: cardtX,
                    top: cardtY,
                    width: "fit-content",
                    height: cardHeight,
                    minWidth: 200,

                    // 最高层级，超越所有元素
                    zIndex: isShow ? 999999 : -1,

                    // 性能优化 - GPU加速
                    willChange: 'opacity, transform',
                    backfaceVisibility: 'hidden',
                    perspective: '1000px',

                    // 样式
                    background: '#fff',
                    borderRadius: '10px',
                    boxShadow: `
                        0 16px 40px rgba(0, 0, 0, 0.12),
                        0 8px 24px rgba(0, 0, 0, 0.08),
                        0 4px 12px rgba(0, 0, 0, 0.06)
                    `,
                    border: '1px solid rgba(0, 0, 0, 0.04)',
                    padding: '12px',
                    fontSize: '14px',
                    fontFamily: "'Inter', sans-serif",

                    // 高级动画效果
                    opacity: popupTopicCard.isVisible && isShow ? 1 : 0,
                    transform: popupTopicCard.isVisible
                        ? 'scale(1) translateZ(0)'
                        : 'scale(0.96) translateZ(0)',
                    transition: 'all 0.4s',

                    // 避免选择和滚动
                    userSelect: 'none',
                    WebkitUserSelect: 'none',

                    // 确保在所有元素之上
                    isolation: 'isolate'
                }}
                onClick={(e) => e.stopPropagation()}
                onMouseEnter={(e) => e.stopPropagation()}
                onMouseLeave={(e) => {
                    e.stopPropagation();
                    hidePopupTopicCard();
                    hidePopupCard();
                }}
            >
                {/* 三角形指针 */}
                <div
                    style={{
                        position: 'absolute',
                        left: triangleX + (t_width / 2),
                        top: triangleY + 10,
                        width: 0,
                        height: 0,
                        borderStyle: 'solid',
                        borderWidth: `${triangleSize}px ${triangleSize}px ${triangleSize}px 0`,
                        borderColor: isOnLeft
                            ? 'transparent transparent transparent #fff'
                            : 'transparent #fff transparent transparent',
                        filter: isOnLeft
                            ? 'drop-shadow(1px 0 2px rgba(0, 0, 0, 0.08))'
                            : 'drop-shadow(-1px 0 2px rgba(0, 0, 0, 0.08))',
                        transform: 'rotate(-90deg)',
                        zIndex: 999
                    }}
                />

                {/* 卡片头部 */}
                <div>
                    <div style={{
                        display: 'flex',
                        gap: '8px',
                        marginBottom: '4px',
                        // minHeight: '30px',
                        maxWidth: 180
                    }}>
                        <div className="ellipsis_2" style={{
                            fontSize: '14px',
                            fontWeight: '600',
                            color: '#1a1a1a',
                            flex: 1,
                        }}>
                            {data.title}
                        </div>
                    </div>
                </div>
                <div style={{ width: '100%', height: '1px', background: '#e0e0e0', margin: '12px 0' }}></div>
                {/* 统计信息 */}
                <div>
                    <div style={{
                        display: 'flex',
                        gap: '5px',
                        marginBottom: '8px'
                    }}>
                        <span className="Every_Card_Desc">{t("Average KD")}:</span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <Badge tone={data.avgKD <= 29 ? 'success' : data.avgKD <= 49 ? 'attention' : data.avgKD <= 69 ? 'warning' : 'critical'}>{`${data.avgKD}`}</Badge>
                        </div>
                    </div>
                    <div style={{
                        display: 'flex',
                        gap: '5px',
                        marginBottom: '8px'
                    }}>
                        <span className="Every_Card_Desc">{t("Total search volume")}:</span>
                        <span style={{ fontWeight: '600', color: '#1a1a1a' }}>
                            {formatNumber(data.totalSearchVolume)}
                        </span>
                    </div>
                </div>
            </div>
        );
    }, [viewLoading, popupTopicCard, hidePopupTopicCard]);

    // 渲染弹出卡片 - 支柱页面 || 子页面
    const renderPopupCard = useCallback(() => {
        if (!popupCard.data) return null;

        let isShow = true;
        if (!popupCard.isVisible || !popupCard.data || !popupCard.position) {
            isShow = false;
        }

        const { data, position, topicId } = popupCard;

        // 卡片尺寸
        const cardWidth = 210;
        const cardHeight = 220;
        const triangleSize = 8;
        const gap = 16; // 与文字的间距

        // 计算卡片位置（在文字右侧，垂直居中对齐）
        let cardX = position.x + gap;
        let cardY = position.y - cardHeight / 2.2; // 以文字中心为基准垂直居中

        // 边界检测
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        // 右边界检测 - 如果右侧空间不足，显示在左侧
        let isOnLeft = false;
        if (cardX + cardWidth > viewportWidth - 20) {
            cardX = position.x - cardWidth - gap;
            isOnLeft = true;
        }

        // 上边界检测
        if (cardY < 20) {
            cardY = 20;
        }

        // 下边界检测
        if (cardY + cardHeight > viewportHeight - 20) {
            cardY = viewportHeight - cardHeight - 20;
        }

        // 计算三角形位置
        const triangleX = isOnLeft ? cardWidth - 1 : -triangleSize;
        const triangleY = Math.max(
            triangleSize * 2,
            Math.min(
                cardHeight - triangleSize * 2,
                position.y - cardY
            )
        );

        return (
            <div
                className="keyword-popup-card"
                style={{
                    // 固定定位，跟随文字位置，最高层级
                    position: 'fixed',
                    left: cardX,
                    top: cardY + (popupCard.type === 'pillar' ? 20 : 0),
                    width: "fit-content",
                    height: "auto",
                    minWidth: 200,

                    // 最高层级，超越所有元素
                    zIndex: isShow ? 999999 : -1,

                    // 性能优化 - GPU加速
                    willChange: 'opacity, transform',
                    backfaceVisibility: 'hidden',
                    perspective: '1000px',

                    // 样式
                    background: '#fff',
                    borderRadius: '10px',
                    boxShadow: `
                        0 16px 40px rgba(0, 0, 0, 0.12),
                        0 8px 24px rgba(0, 0, 0, 0.08),
                        0 4px 12px rgba(0, 0, 0, 0.06)
                    `,
                    border: '1px solid rgba(0, 0, 0, 0.04)',
                    padding: '12px',
                    fontSize: '14px',
                    fontFamily: "'Inter', sans-serif",

                    // 高级动画效果
                    opacity: popupCard.isVisible && isShow ? 1 : 0,
                    transform: popupCard.isVisible
                        ? 'scale(1) translateZ(0)'
                        : 'scale(0.96) translateZ(0)',
                    transition: 'all 0.3s',

                    // 避免选择和滚动
                    userSelect: 'none',
                    WebkitUserSelect: 'none',

                    // 确保在所有元素之上
                    isolation: 'isolate'
                }}
                onClick={(e) => e.stopPropagation()}
                onMouseEnter={(e) => e.stopPropagation()}
                onMouseLeave={(e) => {
                    e.stopPropagation();
                    hidePopupTopicCard();
                    hidePopupCard();
                }}
            >
                {/* 三角形指针 */}
                <div
                    style={{
                        position: 'absolute',
                        left: triangleX,
                        top: (triangleY - triangleSize) + (popupCard.type === 'pillar' ? -10 : -1),
                        width: 0,
                        height: 0,
                        borderStyle: 'solid',
                        borderWidth: isOnLeft
                            ? `${triangleSize}px 0 ${triangleSize}px ${triangleSize}px`
                            : `${triangleSize}px ${triangleSize}px ${triangleSize}px 0`,
                        borderColor: isOnLeft
                            ? 'transparent transparent transparent #fff'
                            : 'transparent #fff transparent transparent',
                        filter: isOnLeft
                            ? 'drop-shadow(1px 0 2px rgba(0, 0, 0, 0.08))'
                            : 'drop-shadow(-1px 0 2px rgba(0, 0, 0, 0.08))',
                        zIndex: 999
                    }}
                />

                {/* 卡片头部 */}
                <div>
                    <div style={{
                        display: 'flex',
                        marginBottom: '4px',
                        // minHeight: '30px',
                        maxWidth: data.isCovered ? 180 : 200,
                        justifyContent: "space-between"
                    }}>
                        <div className="ellipsis_2" style={{
                            fontSize: '14px',
                            fontWeight: '600',
                            color: '#1a1a1a',
                            flex: 1,
                        }}>
                            {data.title}
                        </div>
                        <div className="Covered_tag" style={{ display: data.isCovered ? 'block' : 'none' }}>
                            <span>{t("Covered")}</span>
                        </div>
                    </div>
                </div>
                <div style={{ width: '100%', height: '1px', background: '#e0e0e0', margin: '12px 0' }}></div>
                {/* 统计信息 */}
                <div>
                    <div style={{
                        display: 'flex',
                        gap: '5px',
                        marginBottom: '8px'
                    }}>
                        <span className="Every_Card_Desc">{t("Average KD")}:</span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <Badge tone={data.avgKD <= 29 ? 'success' : data.avgKD <= 49 ? 'attention' : data.avgKD <= 69 ? 'warning' : 'critical'}>{`${data.avgKD}`}</Badge>
                        </div>
                    </div>
                    <div style={{
                        display: 'flex',
                        gap: '5px',
                        marginBottom: '8px'
                    }}>
                        <span className="Every_Card_Desc">{t("Total search volume")}:</span>
                        <span style={{ fontWeight: '600', color: '#1a1a1a' }}>
                            {formatNumber(data.totalSearchVolume)}
                        </span>
                    </div>
                    <div style={{
                        display: 'flex',
                        gap: '5px',
                        marginBottom: '8px'
                    }}>
                        <span className="Every_Card_Desc">{t("Keyword Count")}:</span>
                        <span style={{ fontWeight: '600', color: '#1a1a1a' }}>
                            {data.keywordsCount}
                        </span>
                    </div>
                </div>
                <div style={{ width: '100%', height: '1px', background: '#e0e0e0', margin: '12px 0' }}></div>
                <div className="flex_layout">
                    {
                        data.isCovered ? <Button size="micro" icon={ViewIcon} loading={viewLoading} onClick={() => handleViewBlog(data.blog_config_id)}>{t("View blog")}</Button> : <Button size="micro" icon={BlogIcon} disabled={viewLoading} onClick={() => handleGenerateBlog(data.id)}>{t("Generate")}</Button>
                    }
                    <Button size="micro" onClick={() => {
                        handleViewPageItem(topicId, data.id);
                        hidePopupCard();
                    }}>{t("View Details")}</Button>
                </div>
            </div>
        );
    }, [viewLoading, popupCard, hidePopupCard]);

    // 渲染子页面组件
    const renderSubpage = useCallback((subpage, index, isActive, isTip) => {
        const { id, title, position, radius = 36, strokeWidth = 0, textDecoration = "none", cover, mbShow, isFirst, topic_id, page_id } = subpage;
        const subStrokeActive = Number(id) === Number(hoverNodeId);

        if (!title) {
            return (
                <g key={id} data-subpage={id} data-index={index}>
                    <circle
                        data-subpage-circle={id}
                        fill={`url(${isActive ? "#subpage-active-gradient" : "#subpage-gradient"})`}
                        cx={position.x}
                        cy={position.y}
                        r={radius}
                        stroke={`url(${isActive ? "#subpage-active-gradient" : "#subpage-gradient"})`}
                        strokeOpacity="0.35"
                        strokeWidth={subStrokeActive ? 12 : strokeWidth}
                    />
                </g>
            );
        }

        const textWidth = (title.length * 8) > 180 ? 180 : (title.length * 9); // 估算文字宽度
        const labelWidth = textWidth; // 加上padding
        const labelX = position.x - labelWidth * 0.625 / 4.5;
        const labelScale = 1.6 / matrixRef.current[0];
        const subCount = matrixRef.current[0] >= 1 ? 10 : 20;
        const labelY = position.y - (labelScale * matrixRef.current[0] * subCount) - 2;

        return (
            <g
                id={id}
                key={id}
                data-subpage={id}
                data-index={index}
                onMouseEnter={(e) => handleNodeMouseEnter(e, e.currentTarget)}
                onMouseLeave={(e) => handleNodeMouseLeave(e, e.currentTarget, 'subpage', isFirst ? 0 : 1)}
            >
                <circle
                    data-subpage-circle={id}
                    fill={`url(${cover ? (isActive ? "#subpage-circle-active-gradient" : "#subpage-circle-gradient") : (isActive ? "#subpage-active-gradient" : "#subpage-gradient")})`}
                    cx={position.x}
                    cy={position.y}
                    r={radius}
                    stroke={`url(${cover ? (isActive ? "#subpage-circle-active-gradient" : "#subpage-circle-gradient") : (isActive ? "#subpage-active-gradient" : "#subpage-gradient")})`}
                    strokeOpacity="0.35"
                    strokeWidth={subStrokeActive ? 12 : strokeWidth}
                />
                <g
                    data-subpage-label={id}
                    transform={`translate(${labelX},${labelY}) scale(${labelScale < 1.2 ? 1.2 : labelScale})`}
                    opacity={!isActive ? 0 : 1}
                    display={(matrixRef.current[0] < 1 && !mbShow) ? "none" : "block"}
                    className="subpage-label-wrapper"
                >
                    <path
                        subpage-label-background={id}
                        strokeWidth="1"
                        stroke={cover ? "#ffdca2" : "#e6ccff"}
                        fill={`url(${cover ? "#subpage-info-gradient" : "#subkeyword-gradient"})`}
                        // filter="drop-shadow(0px 0px 1px rgba(25, 27, 35, 0.16)) drop-shadow(0px 1px 2px rgba(25, 27, 35, 0.12))"
                        d={`M0,8C0,8,0,0,8,0L${labelWidth},0C${labelWidth},0,${labelWidth + 8},0,${labelWidth + 8},8L${labelWidth + 8},20C${labelWidth + 8},20,${labelWidth + 8},28,${labelWidth},28L8,28C8,28,0,28,0,20L0,8`}
                    />
                    <foreignObject
                        subpage-title={id}
                        x="8"
                        y="4"
                        width={labelWidth}
                        height="20"
                        className="subpage-title-wrapper"
                        style={{
                            color: cover ? "#eb9d0d" : "#7B61FF",
                            textDecorationColor: cover ? "#eb9d0d" : "#7B61FF",
                        }}
                        textDecoration={textDecoration}
                    >
                        <div
                            style={{
                                width: "95%",
                                height: "100%",
                                fontSize: "18px",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                overflow: "hidden"
                            }}
                            onMouseOver={(e) => handleTextMouseEnter(e, id, isTip, 'subpage')}
                            onMouseLeave={handlePillarMouseLeave}
                            onClick={() => {
                                handleViewPageItem(topic_id, page_id);
                            }}
                        >
                            {title}
                        </div>
                    </foreignObject>
                </g>
            </g>
        );
    }, [handleNodeMouseEnter, handleNodeMouseLeave, hoverNodeId]);

    // 渲染Topic模块
    const renderTopicModule = useCallback((data) => {
        const { id, title, keywordsCount, position, subkeywords, isShowMinCircle, active, isShowSubsText, cover, topic_id, pillar_id } = data;
        const isTip = Number(id) === Number(activeTopicIdRef.current);
        const isActive = (Boolean(active) && Number(activeTopicIdRef.current) === -1) || isTip || Number(id) === Number(hoverTopicId);   // 是否是当前激活的Topic
        const strokeActive = Number(id) === Number(hoverNodeId);   // 触摸效果

        return (
            <g
                key={id}
                data-topic={id}
                data-topic-id={topic_id}
                className="topic-svg-module"
                style={{ cursor: "pointer" }}
                transform={`translate(${position.x}, ${position.y})`}
                onClick={(e) => handleElementClick(e, e.currentTarget)}
                onMouseEnter={(e) => handleElementMouseEnter(e, e.currentTarget)}
                onMouseLeave={(e) => handleElementMouseLeave(e, e.currentTarget)}
            >
                {/* 背景悬停圆 */}
                <circle
                    r="240"
                    data-topic-hover={id}
                    fill="rgba(233, 247, 255, 0)"
                    onMouseEnter={(e) => handleTextMouseTopicEnter(e, id, isTip, 'topic')}
                    onMouseLeave={handlePillarMouseTopicLeave}
                />

                {/* 子页面弧形文字 */}
                <g data-subpage-arc-text="219647065" transform="translate(-4,-205)" opacity={isTip && isShowSubsText ? 1 : 0}>
                    <path id="lvl3rg" d="M-25.58,-11.386A28,28,0,1,1,0,28L0,24A24,24,0,1,0,-21.926,-9.759Z" stroke="none" fill="none" />
                    <text>
                        <textPath xlinkHref="#lvl3rg" fontSize="22px" letterSpacing="1.4" fill="#616161">
                            subs
                        </textPath>
                    </text>
                </g>

                {/* 支柱弧形文字 */}
                <g data-pillar-arc-text={id} transform="translate(-40, -40)" opacity={isTip ? 1 : 0}>
                    <path id="h7nb4r" d="M-50.446,-39.385A64,64,0,1,1,0,64L0,60A60,60,0,1,0,-47.294,-36.923Z" stroke="none" fill="none" />
                    <text>
                        <textPath xlinkHref="#h7nb4r" fontSize="22px" letterSpacing="1.2" fill="#616161">
                            pillar
                        </textPath>
                    </text>
                </g>

                {/* 主题弧形文字 */}
                <g
                    id={`topic-module-${id}`}
                    data-topic-arc-text-wrapper={id}
                    transform="translate(-60, -35) scale(1.2)"
                    opacity={isTip ? 1 : 0}
                    onMouseEnter={(e) => handleTextMouseTopicEnter(e, id, isTip, 'topic')}
                    onMouseLeave={handlePillarMouseTopicLeave}
                >
                    <path
                        id="iu5fx0"
                        d="M-86.218,-58.159A104,104,0,0,1,0,-104L0,-100A100,100,0,0,0,-82.902,-55.922Z"
                        stroke="none"
                        fill="none"
                    />
                    <text>
                        <textPath
                            data-topic-arc-text={id}
                            xlinkHref="#iu5fx0"
                            fontSize="22px"
                            letterSpacing="1.2"
                            fill="#616161"
                        >
                            topic
                        </textPath>
                    </text>
                </g>

                {/* 主题边框圆 */}
                <circle
                    r="180"
                    data-topic-circle={id}
                    stroke={`url(${isActive ? "#topic-active-gradient" : "#topic-gradient"})`}
                    fill="transparent"
                    onMouseEnter={(e) => handleTextMouseTopicEnter(e, id, isTip, 'topic')}
                    onMouseLeave={handlePillarMouseTopicLeave}
                />

                {/* 子页面和支柱内容 */}
                <g>
                    {/* 渲染所有子页面 */}
                    {subkeywords.map((subpage, index) => renderSubpage(subpage, index, isActive, isTip))}

                    {/* 更多子页面指示器 */}
                    <circle
                        data-subpage-more="219646993"
                        r="24"
                        cx="-5.711193794110291"
                        cy="179.83677812032055"
                        fill={`url(${isActive ? "#subpage-active-gradient" : "#subpage-gradient"})`}
                        stroke={`url(${isActive ? "#subpage-active-gradient" : "#subpage-gradient"})`}
                        strokeOpacity="0.35"
                        strokeWidth="0"
                        opacity={isShowMinCircle ? 1 : 0}
                    />

                    {/* 支柱内容 */}
                    <g
                        id={id}
                        data-pillar={id}
                        onMouseEnter={(e) => handleNodeMouseEnter(e, e.currentTarget)}
                        onMouseLeave={(e) => handleNodeMouseLeave(e, e.currentTarget, 'topic', 0)}
                    >
                        <circle
                            data-pillar-circle={id}
                            fill={`url(${cover ? (isActive ? "#subpage-circle-active-gradient" : "#subpage-circle-gradient") : (isActive ? "#pillar-active-gradient" : "#pillar-gradient")})`}
                            r="110"
                            stroke={`url(${cover ? (isActive ? "#subpage-circle-active-gradient" : "#subpage-circle-gradient") : (isActive ? "#pillar-active-gradient" : "#pillar-gradient")})`}
                            strokeOpacity="0.35"
                            strokeWidth={strokeActive ? 16 : 0}
                        />

                        <g
                            data-pillar-label={id}
                            x="-63.3359375"
                            y="-14"
                            width="100%"
                            height="100%"
                            data-origin-text-width="100%"
                            transform={`translate(${isActive ? pillarTranslate.x : pillarTranslateOther.x},${isActive ? pillarTranslate.y : pillarTranslateOther.y}) scale(${pillarScale})`}
                        >
                            <g transform="scale(1.58, 1.25)">
                                <path
                                    strokeWidth="1"
                                    stroke={cover ? "#ffdca2" : "#e6ccff"}
                                    data-pillar-label-background={id}
                                    fill={`url(${cover ? "#subpage-info-gradient" : "#subkeyword-gradient"})`}
                                    // filter="drop-shadow(0px 0px 1px rgba(25, 27, 35, 0.16)) drop-shadow(0px 1px 2px rgba(25, 27, 35, 0.12))"
                                    d={isActive ? "M0,8C0,8,0,0,8,0L118.671875,0C118.671875,0,126.671875,0,126.671875,8L126.671875,40C126.671875,40,126.671875,48,118.671875,48L8,48C8,48,0,48,0,40L0,8" : "M0,8C0,8,0,0,8,0L120.48749999999998,0C120.48749999999998,0,128.48749999999998,0,128.48749999999998,8L128.48749999999998,20C128.48749999999998,20,128.48749999999998,28,120.48749999999998,28L8,28C8,28,0,28,0,20L0,8"}
                                />
                            </g>
                            <foreignObject
                                data-pillar-title={id}
                                x="8"
                                y="4"
                                width="180"
                                height="25"
                                className="pillar-title-wrapper"
                                style={{
                                    color: cover ? "#eb9d0d" : "#7B61FF",
                                    textDecorationColor: cover ? "#eb9d0d" : "#7B61FF",
                                    cursor: "pointer"
                                }}
                                textDecoration="none"

                            >
                                <div
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        fontSize: "22px",
                                        lineHeight: "25px",
                                        textAlign: "center",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden"
                                    }}
                                    // onTouchStart={(e) => handleTextTouch(e, id)}
                                    onMouseEnter={(e) => handleTextMouseEnter(e, id, isTip, 'pillar')}
                                    onMouseLeave={handlePillarMouseLeave}
                                    onClick={() => {
                                        handleViewPageItem(topic_id, pillar_id);
                                    }}
                                >
                                    {title}
                                </div>
                            </foreignObject>
                            <foreignObject
                                data-pillar-keywords-count={id}
                                x="8"
                                y="24"
                                width="180"
                                height="25"
                                style={{
                                    opacity: isActive ? 1 : 0,
                                    color: "rgb(108, 110, 121)",
                                    textDecorationColor: "rgb(108, 110, 121)",
                                    cursor: "pointer",
                                }}
                            >
                                <div style={{
                                    width: "100%",
                                    height: "100%",
                                    fontSize: "20px",
                                    marginTop: "8px",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    textAlign: "center",
                                    overflow: "hidden"
                                }}>
                                    {t("Keywords")}: {keywordsCount}
                                </div>
                            </foreignObject>
                        </g>
                    </g>
                </g>
            </g>
        );
    }, [activeTopicId, hoverTopicId, hoverNodeId, pillarScale, pillarTranslate, handleElementClick, renderSubpage, handleTextMouseEnter, handlePillarMouseLeave, handleTextMouseTopicEnter, handlePillarMouseTopicLeave]);

    return <>
        {/* 弹出卡片 - 最高层级，不受容器限制 */}
        {renderPopupCard()}
        {renderTopicPopupCard()}

        <div id="planner-panel">
            {/* 玻璃面板 */}
            {isShowGlassPanel && <div className="keyword-glass-panel"></div>}

            {/* 放大放小按钮 */}
            <div className="keyword-zoom-btn">
                <Button variant="tertiary" icon={MinusIcon} disabled={svgPercent <= 70} onClick={() => handleZoomOpera('minus')}></Button>
                <div className="keyword-zoom-percent">{svgPercent}%</div>
                <Button variant="tertiary" icon={PlusIcon} disabled={svgPercent >= 170} onClick={() => handleZoomOpera('add')}></Button>
            </div>

            {/* 内容 */}
            <svg
                ref={svgRef}
                xmlns="http://www.w3.org/2000/svg"
                fontFamily="'Inter', sans-serif"
                viewBox="0, 0, 2000, 800"
                preserveAspectRatio="xMidYMid meet"
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseLeave}
            // onWheel={handleWheel}
            >
                <g ref={viewGroupRef}>
                    {
                        topicList.map(item => renderTopicModule(item))
                    }
                </g>

                {/* 配色 */}
                <defs>
                    {/* 圆环渐变 */}
                    <linearGradient id="topic-active-gradient" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0" stopColor="#7B61FF" stopOpacity="1"></stop>
                    </linearGradient>
                    <linearGradient id="topic-gradient" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0" stopColor="#bdb0ff" stopOpacity="1"></stop>
                    </linearGradient>
                    {/* 支柱渐变 */}
                    <linearGradient id="pillar-gradient" gradientUnits="objectBoundingBox" x1="1" y1="0" x2="1" y2="1">
                        <stop offset="0" stopColor="#bdb0ff"></stop>
                        <stop offset="1" stopColor="#cfb0ff"></stop>
                    </linearGradient>
                    <linearGradient id="pillar-active-gradient" gradientUnits="objectBoundingBox" x1="1" y1="0" x2="1" y2="1">
                        <stop offset="0" stopColor="#7B61FF"></stop>
                        <stop offset="1" stopColor="#A061FF"></stop>
                    </linearGradient>
                    {/* 子页面渐变 */}
                    <linearGradient id="subpage-gradient" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0" stopColor="#bdb0ff"></stop>
                        <stop offset="1" stopColor="#cfb0ff"></stop>
                    </linearGradient>
                    <linearGradient id="subpage-active-gradient" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0" stopColor="#7B61FF"></stop>
                        <stop offset="1" stopColor="#A061FF"></stop>
                    </linearGradient>
                    {/* 子页面文字渐变 */}
                    <linearGradient id="subkeyword-gradient" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0" stopColor="#FFFFFF"></stop>
                        <stop offset="1" stopColor="#EBE2FF"></stop>
                    </linearGradient>
                    {/* 小圆覆盖渐变 - 聚焦 */}
                    <linearGradient id="subpage-circle-active-gradient" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0" stopColor="#FFE000"></stop>
                        <stop offset="1" stopColor="#FF9D00"></stop>
                    </linearGradient>
                    {/* 小圆覆盖渐变 - 失焦 */}
                    <linearGradient id="subpage-circle-gradient" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0" stopColor="#ffebcc"></stop>
                        <stop offset="1" stopColor="#ffeb78"></stop>
                    </linearGradient>
                    {/* 小圆文案覆盖渐变 */}
                    <linearGradient id="subpage-info-gradient" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0" stopColor="#FFFFFF"></stop>
                        <stop offset="1" stopColor="#FFF1DA"></stop>
                    </linearGradient>
                </defs>
            </svg>
        </div>
    </>;
}

// 移到最后，层级最高
function bringToFront(element, type = 'enter') {
    const parent = element.parentNode;
    if (parent) {
        if (type === 'enter') {
            parent.appendChild(element);
        } else {
            parent.insertBefore(element, parent.firstChild);
        }
    }
}

// 单位转换
function formatNumber(num) {
    // 将数字转换为以K为单位
    return (typeof num === 'number' && !isNaN(num) && num >= 1000) ? (num / 1000).toFixed(1) + 'K' : num;
}

export default KeywordPanelSvg;